import { useSelector } from "react-redux";

import { getNodeIdExistsSelector } from "@skilitics/nautilus-core-designer-data";

export const useGetNodeIdExists = () => useSelector(getNodeIdExistsSelector);
